import { normalizeDateOnly } from './dateOnly';
import {
  EMPTY_POLICY_CANCEL_LOG_DATE_RANGE_FILTER,
  normalizePolicyCancelLogDateRangeFilter,
} from './policyCancelLogDateRangeFilter';

export const DEFAULT_POLICY_CANCEL_LOG_EXTRA_FILTERS = {
  selectedRoles: [],
  selectedCancellationDate: { ...EMPTY_POLICY_CANCEL_LOG_DATE_RANGE_FILTER },
};

export const parsePolicyCancelLogExtraFilters = (searchParams, _paramKey, fallback) => {
  const rolesParam = searchParams.get('roles');
  const preset = searchParams.get('cancelPreset');
  const startDate = searchParams.get('cancelStart');
  const endDate = searchParams.get('cancelEnd');

  const selectedRoles = rolesParam ? rolesParam.split(',').filter(Boolean) : fallback.selectedRoles;

  const selectedCancellationDate =
    preset || startDate || endDate
      ? normalizePolicyCancelLogDateRangeFilter({
          preset: preset || null,
          startDate: startDate || null,
          endDate: endDate || null,
        })
      : normalizePolicyCancelLogDateRangeFilter(fallback.selectedCancellationDate);

  return {
    selectedRoles,
    selectedCancellationDate,
  };
};

export const buildPolicyCancelLogRequestFilter = ({
  filter,
  selectedRoles,
  selectedCancellationDate,
}) => ({
  searchText: filter?.searchText || '',
  selectedRoles: Array.isArray(selectedRoles) ? selectedRoles : [],
  selectedCancellationDate: normalizePolicyCancelLogDateRangeFilter(selectedCancellationDate),
});

export const serializePolicyCancelLogExtraFilters = (filters) => {
  const normalizedDate = normalizePolicyCancelLogDateRangeFilter(filters.selectedCancellationDate);
  return {
    roles:
      Array.isArray(filters.selectedRoles) && filters.selectedRoles.length > 0
        ? filters.selectedRoles.join(',')
        : '',
    cancelPreset: normalizedDate.preset || '',
    cancelStart:
      normalizedDate.preset === 'custom' ? normalizeDateOnly(normalizedDate.startDate) || '' : '',
    cancelEnd:
      normalizedDate.preset === 'custom' ? normalizeDateOnly(normalizedDate.endDate) || '' : '',
  };
};
